@import '^scss-config';

.optionsContainer {
  display: grid;
  justify-content: center;

  margin-top: 1rem;
  padding: 1rem 1rem 0;

  border-top: 1px dashed var(--theme-color-grey-20);
  grid-template-columns: repeat(auto-fit, 3rem);
  gap: 1.25rem;
  row-gap: 1rem;
}

.mainImage {
  height: 12.25rem;

  background: var(--background-color);

  @include tablet {
    height: 24.75rem;
  }

  @include desktop {
    height: 32rem;
  }
}
